// Import GA4 E-commerce helper
import * as GA4 from './ga4-ecommerce.js';

(function ($) {
    "use strict";

    function setMinCartQuantity() {
        $('.cart-quantity').each(function () {
            if ($(this).attr('type') !== 'hidden') {
                const minValue = $(this).attr('min') || 0;
                const currentValue = $(this).val();
                if (currentValue === "" || parseFloat(currentValue) < parseFloat(minValue)) {
                    $(this).val(minValue);
                }
            }
        });
    }

    function updateCartQuantity() {
        $('.product').each(function () {
            var $cartLink = $(this).find('[data-cart]');
            var $cartQuantity = $(this).find('.cart-quantity');

            if ($cartLink.length && $cartQuantity.length) {
                var quantity = $cartLink.data('cart');
                $cartQuantity.text(quantity > 0 ? `In cart: ${quantity}` : "");
            }
        });
    }

    async function addToCart(productId, amount, product) {
        try {
            const formData = new FormData();
            formData.append('io', 'basketChange');
            formData.append('ajax', '1');
            formData.append('id_zbozi', productId);
            formData.append('kosik', amount);

            const response = await fetch('/index.php', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json'
                },
                body: formData
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();

            // Update cart display
            updateCartPannel(data.info);
            updateCartProduct(data.item, product);

            // GA4 E-commerce: Add to Cart event
            if (data.item && amount > 0) {
                const productName = product.find('h6').first().text().trim() || 'Unknown Product';
                const priceElement = product.find('h6').first().next();
                const priceText = priceElement.find('.mena').length
                    ? priceElement.text().replace(priceElement.find('.mena').text(), '').trim()
                    : priceElement.text().trim();
                const currency = priceElement.find('.mena').text().trim() || 'CZK';

                GA4.addToCart({
                    item_id: productId,
                    item_name: productName,
                    price: priceText,
                    quantity: amount,
                    currency: currency
                });
            }

        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
        }
    }

    async function fetchCartInfo() {
        try {
            const response = await fetch('/index.php?aio=kosik-panel', {
                method: 'GET',
                headers: {
                    'Accept': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            updateCartPannel(data.info);
        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
        }
    }

    function updateCartProduct(item, product) {
        let quantity = parseFloat(item.kosik);
        if (isNaN(quantity)) {
            quantity = 0;
        }

        if (product.length) {
            const cartQuantityText = product.find('.cart-quantity-text').first();
            if (cartQuantityText.length) {
                const oldQuantity = cartQuantityText.text();
                if (oldQuantity !== quantity) {
                    cartQuantityText.css('animation-name', 'slideOutDown');
                    setTimeout(() => {
                        cartQuantityText.text(quantity > 0 ? quantity : "");
                        cartQuantityText.css('animation-name', 'slideInUp');
                    }, 500); // Match the duration of the slideOutDown animation
                }
            }

            const cartQuantityInput = product.find('.cart-quantity').first();
            if (cartQuantityInput.length) {
                const minAttr = cartQuantityInput.attr('min');
                const min = minAttr ? parseFloat(minAttr) : 0;
                if (!isNaN(min) && min > quantity) {
                    quantity = min;
                }
                cartQuantityInput.val(quantity);
            }
        }
        // Update variant data
        const variant = $('#var' + item.id_zbozi);
        if (variant.length) {
            variant.data('cart', quantity);
        }
    }

    function updateCartPannel(info) {
        const cnt = $('#kosikContainer');
        if (cnt.length) {
            const cartText = cnt.find('.cart-text');
            if (cartText.length) {
                cartText.text(info.kos_pocet);
            }
            const cartLink = cnt.find('.cart-link');
            if (cartLink.length) {
                cartLink.attr('title', `${info.kos_suma_s_dph} ${info.kos_mena}`);
            }
        }
    }

    function addToCartButtonListener() {
        $(document).on('click', '.add-to-cart-btn', function (event) {
            event.preventDefault(); // Prevent the default action (navigation)
            const product = $(this).closest('.product');
            const productId = $(this).attr('data-product-id'); // Use .attr() to read current DOM value
            let amount = parseFloat(product.find('.cart-quantity').val());
            const addOnClick = $(this).data('addOnClick');
            if (isNaN(amount)) {
                amount = 0;
            }
            if (!isNaN(addOnClick)) {
                amount += parseFloat(addOnClick);
            }
            addToCart(productId, amount, product);
        });
    }

    function quantityButtonListener() {
        $(document).on('click', '.quantity button', function () {
            var button = $(this);
            var input = button.parent().parent().find('input');
            var oldValue = parseFloat(input.val());
            var min = parseFloat(input.attr('min')) || 0;
            var step = parseFloat(input.attr('step')) || 1;

            if (button.hasClass('btn-plus')) {
                var newVal = oldValue + step;
            } else {
                var newVal = oldValue - step;
                if (newVal < min) {
                    newVal = min;
                }
            }
            input.val(newVal);
            if (input.hasClass('cart-item-quantity')) {
                updateItemTotal(input);
            }
        });
    }

    function quantityInputListener() {
        $(document).on('input', '.cart-item-quantity', function () {
            updateItemTotal($(this));
        });
    }

    let requestID = 0;
    let debounceTimeout;

    function updateItemTotal(input) {
        var row = input.closest('tr');
        var price = parseFloat(input.data('unit-price'));
        var quantity = parseFloat(input.val());
        var total = price * quantity;

        // Format the total price
        var formattedTotal = total.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        var currency = input.data('currency');
        row.find('.cart-total-price').text(`${formattedTotal} ${currency}`);

        // Debounced and throttled AJAX call to update cart summary
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => {
            requestID++;
            const currentRequestID = requestID;
            const productId = input.data('product-id'); // Ensure productId is retrieved correctly
            const amount = quantity; // Use the calculated quantity as the amount
            updateCartSummary(currentRequestID, productId, amount);
        }, 300);
    }

    async function updateCartSummary(currentRequestID, productId, amount) {
        const formData = new FormData();
        formData.append('io', 'basketChange');
        formData.append('ajax', '1');
        formData.append('id_zbozi', productId);
        formData.append('kosik', amount);
        formData.append('requestID', currentRequestID);
        formData.append('sendInfoTemplate', '1');

        try {
            const response = await fetch('/index.php', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json'
                },
                body: formData
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();

            if (data.requestID === requestID) {
                // Update cart pannel
                updateCartPannel(data.info);
                // Update cart summary with response data
                if (data.infoTemplate) {
                    document.getElementById('cart-summary').innerHTML = data.infoTemplate;
                }
            }
        } catch (error) {
            console.error('Error updating cart summary:', error);
        }
    }

    async function removeFromCart(productId, row) {
        // Get product data before removal for GA4 tracking
        const productName = row.find('td').first().text().trim().split('\n').pop().trim() || 'Unknown Product';
        const priceText = row.find('.cart-unit-price').text().trim().split(' ')[0];
        const currency = row.find('.cart-unit-price').text().trim().split(' ')[1] || 'CZK';
        const quantity = parseInt(row.find('.cart-item-quantity').val()) || 1;

        const formData = new FormData();
        formData.append('io', 'basketRemove');
        formData.append('ajax', '1');
        formData.append('id_zbozi', productId);
        formData.append('requestID', requestID);
        formData.append('sendInfoTemplate', '1');

        try {
            const response = await fetch('/index.php', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json'
                },
                body: formData
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();

            if (data.requestID === requestID) {
                // GA4 E-commerce: Remove from Cart event
                GA4.removeFromCart({
                    item_id: productId,
                    item_name: productName,
                    price: priceText,
                    quantity: quantity,
                    currency: currency
                });

                if (data.info.kosik_pocet === 0) {
                    location.reload();
                }
                // Remove the product row from the table
                row.remove();
                // Update cart pannel
                updateCartPannel(data.info);
                // Update cart summary with response data
                if (data.infoTemplate) {
                    document.getElementById('cart-summary').innerHTML = data.infoTemplate;
                }
            }
        } catch (error) {
            console.error('Error removing item from cart:', error);
        }
    }

    function removeFromCartButtonListener() {
        $(document).on('click', '.cart-remove-btn', function () {
            const button = $(this);
            const productId = button.data('productId');
            const row = button.closest('tr');
            requestID++;
            removeFromCart(productId, row);
        });
    }

    $(document).ready(function () {
        setMinCartQuantity();
        updateCartQuantity();
        addToCartButtonListener();
        quantityButtonListener();
        quantityInputListener();
        removeFromCartButtonListener();
    });

})(jQuery);